import { Component, Vue, PropSync, Emit } from 'vue-property-decorator';
import { LoggerService } from '@/utils';
import { Helpers } from '@/helpers/Helpers';
import { DexieFilter } from '@/models/dexie/DexieFilter';
import { FilterNewService } from '@/services/index';

import ShareFilter from '@/components/filter/ShareFilter.vue';

@Component({
    components: {
        ShareFilter,
    },
})
export default class FilterCardComponent extends Vue {
    @PropSync('filter', { type: Object }) public syncedFilter!: DexieFilter;

    public share: boolean = false;

    // tslint:disable-next-line: no-empty
    public async mounted() {}

    @Emit()
    public download(inFilter: DexieFilter): DexieFilter {
        return inFilter;
    }

    public getDateTime(created: string): string {
        let datetimeString = Helpers.getFormattedDateString(created);
        datetimeString = datetimeString.replace('T', ' | ');
        return datetimeString;
    }

    public onClick() {
        // TODO: how to generate UsedFilterForDataSetFilters in this case?
        FilterNewService.UsedFilterForDataSets = this.syncedFilter;
        this.$router.push({ name: 'table', query: { myFilter: 'true' } });
    }

    public onEdit() {
        FilterNewService.UsedFilterForDataSets = this.syncedFilter;
        this.$router.push({ name: 'filterNew', query: { myFilter: 'true' } });
    }

    public onShare() {
        this.share = true;
    }

    public onDownload() {
        this.download(this.syncedFilter);
    }
}
